import type { BookingChargeExportRow } from '@court-sync/shared';

/** CSV rows for Excel; UTF-8 CSV via downloadCSV. */
export function buildBookingChargesCsvRows(
  rows: BookingChargeExportRow[]
): Record<string, string | number | boolean | undefined>[] {
  return rows.map((r) => ({
    'Booking ID': r.bookingId,
    'Booking created (UTC)': r.bookingCreatedAt,
    'Student first name': r.studentFirstName,
    'Student last name': r.studentLastName,
    'Guardian / payer name': r.guardianName,
    'Guardian / payer email': r.guardianEmail,
    'Lesson': r.lessonName,
    'Lesson type': r.lessonType,
    Term: r.termName,
    'Session date': r.sessionDate,
    'Booking status': r.bookingStatus,
    'Payment status': r.paymentStatus,
    'Amount (booking)': r.totalAmount,
    Currency: r.currency,
    'Card payment date (UTC)': r.paymentPaidAt,
    'Card payment amount': r.cardPaymentAmount,
  }));
}
